/**
 * Registro único de recursos para el módulo de disponibilidad.
 *
 * Los nombres respetan exactamente las exportaciones finales. En servidores
 * Linux las mayúsculas y minúsculas sí importan.
 */
export const AVAILABILITY_ASSETS = {
  buildingImage: '/availability/images/SLS_pisos.webp',
  buildingSvg: '/availability/svg/SLS_disponibilidad_pisos.svg',
  floorImages: {
    1: '/availability/images/SLS_piso1.webp',
    2: '/availability/images/SLS_piso2-5.webp',
    3: '/availability/images/SLS_piso2-5.webp',
    4: '/availability/images/SLS_piso2-5.webp',
    5: '/availability/images/SLS_piso2-5.webp',
    6: '/availability/images/SLS_piso6-7.webp',
    7: '/availability/images/SLS_piso6-7.webp',
  },
  floorSvgs: {
    1: '/availability/svg/SLS_disponibilidad_piso1.svg',
    2: '/availability/svg/SLS_disponibilidad_piso2.svg',
    3: '/availability/svg/SLS_disponibilidad_piso3.svg',
    4: '/availability/svg/SLS_disponibilidad_piso4.svg',
    5: '/availability/svg/SLS_disponibilidad_piso5.svg',
    6: '/availability/svg/SLS_disponibilidad_piso6.svg',
    7: '/availability/svg/SLS_disponibilidad_piso7.svg',
  },
};

export const getFloorImage = (floor) => AVAILABILITY_ASSETS.floorImages[Number(floor)] || '';

export const getFloorSvg = (floor) => AVAILABILITY_ASSETS.floorSvgs[Number(floor)] || '';

const SERVER_SLS_URL = (
  import.meta.env.VITE_SERVER_SLS_URL || 'https://serversls.koppi.mx'
).replace(/\/$/, '');

const QUOTE_BASE_URL = (import.meta.env.VITE_AVAILABILITY_QUOTE_URL || '').trim();

export const getDepartmentDetailUrl = (departmentNumber) => (
  `${SERVER_SLS_URL}/departamento/${encodeURIComponent(departmentNumber)}`
);

export const buildQuoteUrl = ({ department, fraction, floor, price }) => {
  if (!QUOTE_BASE_URL) return '';

  const url = new URL(QUOTE_BASE_URL, window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);

  url.searchParams.set('departamento', department);
  if (fraction) url.searchParams.set('fraccion', fraction);
  if (floor) url.searchParams.set('piso', floor);
  if (price) url.searchParams.set('precio', price);

  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const value = currentParams.get(key);
    if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
  }

  return url.toString();
};
